import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial
      values.tipoDocumentoSocio = data.tipoDocumento

      setValues(values)

      KeyEventUtil.leaveOnKeyEvent('select-partida')
    })
  }

  const onCreate = React.useCallback(
    (socioCreado, closeModal) => {
      values._idSocio = socioCreado._id
      values.codigoSocio = socioCreado.codigo
      values.documentoSocio = socioCreado.numeroDocumento
      values.nombreSocio = socioCreado.razonSocial
      values.tipoDocumentoSocio = socioCreado.tipoDocumento

      setValues(values)
      closeModal()
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values._idSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.nombreSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('select-sociootros')
  }, [setValues, values])

  return (
    <>
      <Form.Group>
        <Form.Label text='DNI' htmlFor='input-codigoRucSocio' md={2} alignRightAt='md' />
        <Col md={10}>
          {iValue ? (
            <ClearInputGroup
              id='codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
            />
          ) : (
            <>
              <Select2SocioOtros
                disabled={fIsSubmitting}
                id='select-sociootros'
                onChange={onChangeSocioHandler}
                showNewButton
                onCreate={onCreate}
              />
            </>
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
